import { Cloud } from '@silbo/core';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from '../../../toast';

const STARTED_BY_ANOTHER = 'Another agent has started this mission';
const TAKEN_BY_ANOTHER = 'Another agent has taken this mission';

const messageIncludes = (error: unknown, text: string): boolean =>
  error instanceof Error && error.message.includes(text);

/** Les gestes de l'agent sur une mission. La liste et la mission se mettent à jour par le temps réel, rien à recharger. */
export const useCleaningMissionGestures = (missionId: string) => {
  const { t } = useTranslation('environmental-cleaning');

  const start = useMutation({
    mutationFn: () => Cloud.startCleaningMission({ missionId }),
    onError: (error) =>
      toast.error(messageIncludes(error, STARTED_BY_ANOTHER) ? t('actions.startedByAnother') : t('actions.startError')),
  });
  const interrupt = useMutation({
    mutationFn: (comment: string) => Cloud.interruptCleaningMission({ missionId, comment }),
    onError: () => toast.error(t('actions.interruptError')),
  });
  const finish = useMutation({
    mutationFn: () => Cloud.finishCleaningMission({ missionId }),
    onError: () => toast.error(t('actions.finishError')),
  });
  const reserve = useMutation({
    mutationFn: () => Cloud.assignCleaningMission({ missionId }),
    onError: (error) =>
      toast.error(
        messageIncludes(error, TAKEN_BY_ANOTHER) ? t('actions.reservedByAnother') : t('actions.reserveError')
      ),
  });
  const cancelReservation = useMutation({
    mutationFn: () => Cloud.unassignCleaningMission({ missionId }),
    onError: () => toast.error(t('actions.cancelReservationError')),
  });

  const isPending = [start, interrupt, finish, reserve, cancelReservation].some((mutation) => mutation.isPending);

  return {
    start: start.mutate,
    interrupt: interrupt.mutateAsync,
    finish: finish.mutate,
    reserve: reserve.mutate,
    cancelReservation: cancelReservation.mutate,
    isPending,
  };
};
